"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sites = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var types = _interopRequireWildcard(require("../types/sites"));
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const initialState = {
  sites: {
    byId: {},
    filters: {
      activeFilters: {},
      data: {}
    },
    isSingleSite: false,
    active: null,
    errors: []
  }
};
const sites = function sites() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.sites;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case types.GET_SITES_SUCCEEDED:
      {
        const parsingList = payload === null || payload === void 0 ? void 0 : payload.map(site => {
          const {
            thingLatitude = _constants.defaultCoordinate.latitude,
            thingLongitude = _constants.defaultCoordinate.longitude
          } = site.coordinates || {};
          return _objectSpread(_objectSpread({}, site), {}, {
            coordinates: {
              latitude: thingLatitude > _constants.rangeCoordinate.maxLatitude || thingLatitude < _constants.rangeCoordinate.minLatitude ? _constants.defaultCoordinate.latitude : thingLatitude,
              longitude: thingLongitude > _constants.rangeCoordinate.maxLongitude || thingLongitude < _constants.rangeCoordinate.minLongitude ? _constants.defaultCoordinate.longitude : thingLongitude
            }
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          isSingleSite: false,
          byId: parsingList.reduce((acc, s) => _objectSpread(_objectSpread({}, acc), {}, {
            [s.id]: s
          }), {})
        });
      }
    case types.GET_SITE_SUCCEEDED:
      {
        const {
          thingLatitude = _constants.defaultCoordinate.latitude,
          thingLongitude = _constants.defaultCoordinate.longitude
        } = payload.coordinates || {};
        const parsingList = _objectSpread(_objectSpread({}, payload), {}, {
          coordinates: {
            latitude: thingLatitude > _constants.rangeCoordinate.maxLatitude || thingLatitude < _constants.rangeCoordinate.minLatitude ? _constants.defaultCoordinate.latitude : thingLatitude,
            longitude: thingLongitude > _constants.rangeCoordinate.maxLongitude || thingLongitude < _constants.rangeCoordinate.minLongitude ? _constants.defaultCoordinate.longitude : thingLongitude
          }
        });
        const {
          id
        } = parsingList;
        return _objectSpread(_objectSpread({}, state), {}, {
          byId: _objectSpread(_objectSpread({}, state.byId), {}, {
            [id]: parsingList
          }),
          isSingleSite: !Object.keys(state.byId).length
        });
      }
    case types.SET_ACTIVE_SITE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          active: payload
        });
      }
    case types.SET_FILTERS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filters: _objectSpread(_objectSpread({}, state.filters), {}, {
            activeFilters: _objectSpread(_objectSpread({}, state.filters.activeFilters), {}, {
              [payload.name]: payload.filter
            })
          })
        });
      }
    case types.SET_FILTERED_SITES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filters: _objectSpread(_objectSpread({}, state.filters), {}, {
            data: _objectSpread(_objectSpread({}, state.filters.data), {}, {
              [payload.name]: payload.data
            })
          })
        });
      }
    case types.MAKE_SITE_APPROVE_SUCCEEDED:
      return _objectSpread(_objectSpread({}, state), {}, {
        byId: _objectSpread(_objectSpread({}, state.byId), {}, {
          [payload.siteId]: _objectSpread(_objectSpread({}, state.byId[payload.siteId]), {}, {
            isApproved: payload.status
          })
        })
      });
    case types.MAKE_SITE_APPROVE_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'makeSiteApprove'
        }, payload)]
      });
    case types.GET_SITE_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getSite'
        }, payload)]
      });
    case types.GET_SITES_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getSites'
        }, payload)]
      });
    default:
      return state;
  }
};
exports.sites = sites;